import * as actions from "../actions";
import moment from "moment";

const initialState = {
  firstname: null,
  middlename: null,
  lastname: null,
  deceasedState: null,
  birthCertificateIssued: null,
  otherNames: null,
  certificateLongNum: null,
  certificateShortNum: null,
  dayOfBirth: null,
  monthOfBirth: null,
  yearOfBirth: null,
  dayOfDeath: null,
  monthOfDeath: null,
  yearOfDeath: null,
  otherName: null,
  residingNursingHome: null,
  nursingHome: null,
  currentAddress: null,
  currentAddressLastTimestamp: null,
  birth: null,
  death: null,
  submit: false,
};

export default (state = initialState, action) => {

  switch (action.type) {
    case actions.STORE_PERSON_DATA:
      const {dayOfBirth, monthOfBirth, yearOfBirth,
        dayOfDeath, monthOfDeath, yearOfDeath} = action.payload;
      const birth = moment(`${parseInt(dayOfBirth)}-${parseInt(monthOfBirth)}-${parseInt(yearOfBirth)}`,
        "D-M-YYYY").format("YYYY-MM-DD");
      const death = moment(`${parseInt(dayOfDeath)}-${parseInt(monthOfDeath)}-${parseInt(yearOfDeath)}`,
        "D-M-YYYY").format("YYYY-MM-DD");
      return {
        ...state,
        birth,
        death,
        ...action.payload
      }
    case actions.RESET_DATA:
      return {
        ...initialState
      }
    default:
      return state
  }
}
